import React from 'react';
import { Chip, Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import HandshakeIcon from '@mui/icons-material/Handshake';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import EventIcon from '@mui/icons-material/Event';
import EmailIcon from '@mui/icons-material/Email';
import NoteIcon from '@mui/icons-material/Note';
import PhoneIcon from '@mui/icons-material/Phone';
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from 'react-i18next';
import { ACCENT, TEXT_PRIMARY, noMotion } from '../../designsystem/tokens';

const TYPE_ICONS = {
    contact: <PersonIcon sx={{ fontSize: 16 }} />,
    company: <BusinessIcon sx={{ fontSize: 16 }} />,
    deal: <HandshakeIcon sx={{ fontSize: 16 }} />,
    task: <TaskAltIcon sx={{ fontSize: 16 }} />,
    meeting: <EventIcon sx={{ fontSize: 16 }} />,
    mail: <EmailIcon sx={{ fontSize: 16 }} />,
    note: <NoteIcon sx={{ fontSize: 16 }} />,
    call: <PhoneIcon sx={{ fontSize: 16 }} />,
};

function getEntityName(type, entity) {
    if (!entity) return '';
    switch (type) {
        case 'contact':
            return `${entity.firstName || entity.firstname || ''} ${entity.lastName || entity.lastname || ''}`.trim() || entity.email || '';
        case 'company':
            return entity.name || entity.domain || '';
        case 'deal':
            return entity.dealname || entity.name || '';
        case 'task':
            return entity.subject || entity.hs_task_subject || '';
        case 'meeting':
            return entity.title || entity.hs_meeting_title || '';
        case 'mail':
            return entity.subject || entity.hs_email_subject || '';
        case 'note':
            return (entity.content || entity.hs_note_body || '').substring(0, 50);
        case 'call':
            return entity.title || entity.hs_call_title || '';
        default:
            return '';
    }
}

const FlowContextChip = ({ type, entity, onClear }) => {
    const { t } = useTranslation();
    if (!entity || !type) return null;

    const name = getEntityName(type, entity);
    if (!name) return null;

    return (
        <Box sx={{ mb: 1 }}>
            <Chip
                icon={TYPE_ICONS[type] || null}
                label={`${t(type)}: ${name}`}
                data-testid={`flow-chip-${type}`}
                aria-label={`${t(type)}: ${name}`}
                deleteIcon={onClear ? <ClearIcon sx={{ fontSize: 16 }} /> : undefined}
                onDelete={onClear || undefined}
                sx={{
                    minHeight: 44,
                    borderRadius: '12px',
                    backgroundColor: 'rgba(255,255,255,0.04)',
                    border: `1px solid ${ACCENT}30`,
                    color: TEXT_PRIMARY,
                    fontWeight: 500,
                    fontSize: '0.85rem',
                    '& .MuiChip-icon': { color: ACCENT },
                    '& .MuiChip-deleteIcon': { color: 'rgba(255,255,255,0.4)', '&:hover': { color: 'rgba(255,255,255,0.7)' } },
                    transition: 'all 200ms ease-out',
                    ...noMotion,
                }}
            />
        </Box>
    );
};

export default FlowContextChip;
